<template>
  <div>
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('components.MachineConfig.9398863-0')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      top="8vh"
      width="780px"
      @close="handleClose"
    >
      <div :element-loading-text="$t('common.request')">
        <!-- 搜索栏目 -->
        <div style="width: 100%; margin-bottom: 20px">
          <div class="el-search" style="border-radius: 0">
            <div class="el-left">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddMachine">
                {{ $t('components.MachineConfig.9398863-1') }}
              </el-button>
            </div>
            <div class="el-right">
              <el-button type="danger" size="small" icon="el-icon-delete" @click="handleRemoveMachines">
                {{ $t('components.MachineConfig.9398863-2') }}
              </el-button>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="machineList"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40" align="center"></el-table-column>
          <el-table-column prop="equipmentNo" :label="$t('components.MachineConfig.9398863-3')" align="center"></el-table-column>
          <el-table-column prop="equipmentName" :label="$t('components.MachineConfig.9398863-4')" align="center"></el-table-column>
          <el-table-column prop="teamName" :label="$t('components.MachineConfig.9398863-5')" align="center"></el-table-column>
          <el-table-column fixed="right" :label="$t('components.MachineConfig.9398863-6')" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="handleRemoveMachine(scope.row.id)"
                style="padding: 7px"
              >
                {{ $t('components.MachineConfig.9398863-7') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="pagination.totalSize > 0" style="display: flow-root; margin-top: 20px">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="pagination.pageIndex"
            :total="pagination.totalSize"
            :page-size="pagination.pageSize"
            @current-change="getMachineList"
            style="margin-top: 0"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "MachineConfig",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      surveyId: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        loading: false,
        machineList: [],
        pagination: {
          pageIndex: 1,
          pageSize: 10,
          totalSize: 0
        },
        selectedMachines: [] // 存储选中的设备ID列表
      };
    },
    watch: {
      visible(val) {
        this.dialogVisible = val;
        if (val) {
          this.getMachineList();
        }
      }
    },
    created() {
      if (this.dialogVisible) {
        this.getMachineList();
      }
    },
    methods: {
      // 获取问卷关联设备列表
      getMachineList(pageIndex) {
        this.loading = true;
        this.pagination.pageIndex = pageIndex || 1;

        const params = {
          surveyId: this.surveyId,
          pageIndex: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize
        };

        this.$api
          .request(this.$url.Survey.equipmentList, this.$method.get, params)
          .then(res => {
            this.loading = false;
            if (res.code === 0 && res.data) {
              this.machineList = res.data.records || [];
              this.pagination.totalSize = parseInt(res.data.total || 0);
            } else {
              this.$message.error(res.msg || this.$t('components.MachineConfig.9398863-8'));
              this.machineList = [];
            }
          })
          .catch(error => {
            console.error(this.$t('components.MachineConfig.9398863-8'), error);
            this.$message.error(this.$t('components.MachineConfig.9398863-8'));
            this.loading = false;
            this.machineList = [];
          });
      },

      // 表格选择变化
      handleSelectionChange(selection) {
        this.selectedMachines = selection.map(item => item.id);
      },

      // 打开添加设备对话框
      handleAddMachine() {
        this.$emit("add-machine", this.surveyId);
      },

      // 移除单个设备
      async handleRemoveMachine(machineId) {
        try {
          await this.$confirm(this.$t('components.MachineConfig.9398863-9'), this.$t('components.MachineConfig.9398863-10'), {
            confirmButtonText: this.$t('components.MachineConfig.9398863-11'),
            cancelButtonText: this.$t('components.MachineConfig.9398863-12'),
            type: "warning"
          });

          this.loading = true;
          const params = {
            id: this.surveyId,
            ids: [machineId],
            type: 0 // 0表示移除
          };

          const res = await this.$api.request(this.$url.Survey.configmachine, this.$method.post, params);

          if (res.code === 0) {
            this.$message.success(this.$t('components.MachineConfig.9398863-13'));
            this.getMachineList(this.pagination.pageIndex);
          } else {
            this.$message.error(res.msg || this.$t('components.MachineConfig.9398863-14'));
          }
        } catch (error) {
          if (error !== "cancel") {
            console.error(this.$t('components.MachineConfig.9398863-14'), error);
            this.$message.error(this.$t('components.MachineConfig.9398863-14'));
          }
        } finally {
          this.loading = false;
        }
      },

      // 批量移除设备
      async handleRemoveMachines() {
        if (this.selectedMachines.length === 0) {
          this.$message.warning(this.$t('components.MachineConfig.9398863-15'));
          return;
        }

        try {
          await this.$confirm(this.$t('components.MachineConfig.9398863-16', [this.selectedMachines.length]), this.$t('components.MachineConfig.9398863-10'), {
            confirmButtonText: this.$t('components.MachineConfig.9398863-11'),
            cancelButtonText: this.$t('components.MachineConfig.9398863-12'),
            type: "warning"
          });

          this.loading = true;
          const params = {
            id: this.surveyId,
            ids: this.selectedMachines,
            type: 0 // 0表示移除
          };

          const res = await this.$api.request(this.$url.Survey.configmachine, this.$method.post, params);

          if (res.code === 0) {
            this.$message.success(this.$t('components.MachineConfig.9398863-17'));
            this.getMachineList(this.pagination.pageIndex);
          } else {
            this.$message.error(res.msg || this.$t('components.MachineConfig.9398863-18'));
          }
        } catch (error) {
          if (error !== "cancel") {
            console.error(this.$t('components.MachineConfig.9398863-18'), error);
            this.$message.error(this.$t('components.MachineConfig.9398863-18'));
          }
        } finally {
          this.loading = false;
        }
      },

      // 关闭对话框
      handleClose() {
        this.dialogVisible = false;
        this.$emit("close");
      }
    }
  };
</script>

<style lang="scss" scoped>
  .el-search {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    border-radius: 4px;
    background-color: #f5f7fa;
  }
</style>
